import * as ActionTypes from '../action-types'
// import { deepMerge } from '../../util'

const locationTracking_DefaultState = {
    byID: {},
    byCoordinates: {},
    allIDs: []
}

export const locationTracking = (state = locationTracking_DefaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_BATCH_LOCATION_TRACKING: {
            const links = action.links

            links && links.length && links.map(link => {

                const trackid = link.trackid
                
                newState.byID[trackid] = link

                if(!newState.allIDs.includes(trackid)) {
                    newState.allIDs.push(trackid)
                }
            })
            return newState
        }
        case ActionTypes.GET_BATCH_COORDINATE_ADDRESS: {
            const locations = action.locations

            locations && locations.length && locations.map(location => {
                const { lat, lon, address } = location || {}
                const id = `${lat},${lon}`

                if(address) {
                    newState.byCoordinates[id] = address
                }

            })
            return newState
        }
        // case ActionTypes.GET_LOCATION_TRACKING_THRU_UID: {
        //     return newState
        // }
        // case ActionTypes.CREATE_LOCATION_TRACKING: {
        //     return newState
        // }
        case ActionTypes.UPDATE_LOCATION_TRACKING: {
            const link = action.link
            const trackid = link.trackid

            newState.byID[trackid] = link
            
            return newState
        }
        default:
            return newState
    }
}